import React, { Component } from "react"
import TableAditivos from "./TableAditivos"
import Layout from "../../Layout"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
export default class Aditivos extends Component {
  constructor() {
    super()
    this.getAditivos = this.getAditivos.bind(this)
    this.filter = this.filter.bind(this)
    this.state = {
      aditivos: [],
      initialAditivos: [],
      showTable: false,
      currentPage: 1,
      pageCount: ""
    }
  }
  componentWillMount() {
    this.getAditivos(this.state.currentPage)
  }
  getAditivos(page) {
    ApiHelper.getAditivos(this.props.match.params.id, page, aditivos => {
      if (aditivos) {
        this.setState({
          aditivos: aditivos.data,
          initialAditivos: aditivos.data,
          showTable: true,
          pageCount: aditivos.last_page
        })
      } else {
        console.log("error")
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialAditivos.filter(aditivo => {
      return (
        aditivo.objeto.toLowerCase().search(searchText) !== -1 ||
        aditivo.num_contrato.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      aditivos: filtered
    })
  }
  handlePageChange(data) {
    window.scrollTo(0, 0)
    this.getAditivos(data.selected + 1)
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Contratos">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Contratos">
        {this.state.showTable ? (
          <TableAditivos
            pageCount={this.state.pageCount}
            handlePageClick={this.handlePageChange}
            filter={this.filter}
            onDelete={this.getAditivos}
            sizeClass=""
            title="Aditivos"
            subtitle="Listagem de todos os aditivos"
            backgroundColor="as-blue"
            rows={this.state.aditivos}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/contratos/aditivos/Aditivos.js